export default __webpack_public_path__ + "static/media/6.1fc3e6da.jpg";